import {
  shouldBlinkForIncreasedItems,
  startDocumentTitleBlink,
} from '@/common/utils/documentTitleBlink'
import { localPropertiesService } from '@/services/local-properties/local-properties.service'
import { useMenuCountersStore } from '@/stores/menuCounters'
import { useMenuNotificationIgnoreStore } from '@/stores/menuNotificationIgnore'
import { useWebSocketStore } from '@/stores/websocket'
import { watch, onUnmounted } from 'vue'

const HIDE_ALL_NOTIFICATIONS_KEY = 'hide-all-notifications'

export function isHideAllNotificationsEnabled(): boolean {
  const raw = localPropertiesService.get(HIDE_ALL_NOTIFICATIONS_KEY)
  if (typeof raw === 'boolean') return raw
  if (typeof raw === 'string') {
    const normalized = raw.trim().toLowerCase()
    return normalized === 'true' || normalized === '1'
  }
  return Boolean(raw)
}

export function useMenuCounters() {
  const wsStore = useWebSocketStore()
  const store = useMenuCountersStore()
  const ignoreStore = useMenuNotificationIgnoreStore()

  const stopWatcher = watch(
    () => wsStore.events,
    (events) => {
      if (!events?.length) return

      for (const event of events) {
        if (event.type === 'updateCounters') {
          const increasedIds = store.updateCounters(event.data)
          if (
            shouldBlinkForIncreasedItems(
              increasedIds,
              (id) => ignoreStore.isIgnored(id),
              isHideAllNotificationsEnabled(),
            )
          ) {
            startDocumentTitleBlink()
          }
        }
      }
    },
    { deep: true, immediate: true }
  )

  onUnmounted(() => {
    stopWatcher()
  })
}
